import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/pitchyou-logo.png'


const _hoisted_1 = { class: "q-py-sm rounded-borders" }
const _hoisted_2 = { class: "q-pa-sm q-mb-sm row justify-around items-center" }
const _hoisted_3 = {
  key: 0,
  class: "q-pa-md"
}
const _hoisted_4 = { class: "column" }
const _hoisted_5 = {
  key: 1,
  class: "self-end"
}
const _hoisted_6 = {
  key: 2,
  class: "self-end"
}
const _hoisted_7 = {
  key: 1,
  class: "q-pa-md"
}
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "self-end" }
const _hoisted_10 = {
  key: 1,
  class: "row full-width justify-center bg-primary"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { style: {"max-width":"35%"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.pitchyou.de",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "img-fluid"
    })
  ])
], -1)
const _hoisted_12 = [
  _hoisted_11
]

import { ref, onMounted as vueOnMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import QInput from 'quasar/src/components/input/QInput.js';import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { useI18n } from 'vue-i18n';


import {
  LoginRequest,
  ResetPasswordRequest,
  TenantLoginInfo
} from '@/store/models';
import userModule from '@/store/modules/userModule';
import TenantInfo from '@/components/TenantInfo.vue';
import { Tenant } from '../store/models';
import tenantModule from '@/store/modules/tenantModule';
import { showErrorMsgToast, showSuccessMsgToast } from '@/common';
import SessionStorage from 'quasar/src/plugins/storage/SessionStorage.js';;
import { homedir } from 'os';
import LoadingIndicator from '@/components/LoadingIndicator.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

//import { Vue } from 'vue-property-decorator';
const { t, locale } = useI18n();
    const onMounted = vueOnMounted;
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const $q = useQuasar();

    const username = ref('');
    const password = ref('');
    const email = ref('');
    const isPwd = ref(true);
    const tenant = ref<Tenant | null>(null);
    const tenantLoginInfo = ref<TenantLoginInfo | null>(null);
    const isShowResetPassword = ref(false);
    const processLoading = ref(true);
    const loadingIndicatorVisible = ref(true);
    const superAdminCred = ref<boolean | null>(false);
    const isTfaRequired = ref(false);
    const tfaCode = ref<string | null>(null);
    const hideLogin = ref(false);
    const loginError =  ref<string>('');
    const emailRef = ref();
    const usernameRef = ref();
    const passwordRef = ref();
    const tfaCodeRef = ref<QInput | undefined>();
    const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    onMounted(async () => {
    processLoading.value = true;
    try {
      await loadTenantLoginInfo();
      processLoading.value = false;
      if (tenantLoginInfo.value) {
        hideLogin.value = tenantLoginInfo.value.hideLogin;
      }
    } catch (error) {
      loadingIndicatorVisible.value = false;
      showErrorMsgToast(

        t('message.unknownTenantErrorToastMessage') as string
      );
    }
    });


    const loadTenantInfo = async () => {
    tenant.value = tenantModule.tenantInfo || null;
    if (!tenant.value) {
      await tenantModule.loadTenantInfo();
      tenant.value = tenantModule.tenantInfo;
    }
    };

    const loadTenantLoginInfo = async () => {
    tenantLoginInfo.value = tenantModule.tenantLoginInfo || null;
    if (!tenantLoginInfo.value) {
      await tenantModule.loadTenantLoginInfo();
      tenantLoginInfo.value = tenantModule.tenantLoginInfo;
    }
    };

    const onSwitchToResetPassword = () => {
    isShowResetPassword.value = !isShowResetPassword.value;
    const usernameRefValue = usernameRef.value;
    const passwordRefValue = passwordRef.value;
    usernameRefValue.resetValidation();
    passwordRefValue.resetValidation();
    };

    const onSwitchToLogin = () => {
    isShowResetPassword.value = !isShowResetPassword.value;
    const emailRefValue = emailRef.value;
    emailRefValue.resetValidation();
    };

  const onSubmitLogin = async () => {
    if (isShowResetPassword.value) {
      const emailRefValue = emailRef.value;
      emailRefValue.validate();
      if (!emailRefValue.hasError) {
        try {
          const resetPasswordRequest: ResetPasswordRequest = {
            userName: email.value,
          };

          await userModule.performResetPassword(resetPasswordRequest);

          onSwitchToLogin();
          email.value = '';
          showSuccessMsgToast( t('message.resPwEmailSent') as string);
        } catch (error) {
          console.log(error);
          showLoginError();
        }
      }
    } else {
      const usernameRefValue = usernameRef.value;
      const passwordRefValue = passwordRef.value;
      usernameRefValue.validate();
      passwordRefValue.validate();

      if (!usernameRefValue.hasError && !passwordRefValue.hasError) {
        const loginRequest: LoginRequest = {
          username: username.value,
          password: password.value,
          browserLanguage: locale.value,
          tfaCode: tfaCode.value || undefined,
        };
        try {
          userModule.resetUser();
          await userModule.login(loginRequest);

          if (userModule.isLoggedIn) {
            await loadTenantInfo();
            let user = userModule.loggedInUser;
            if (user && user.tfaRequired) {
              isTfaRequired.value = true;
              isPwd.value = true;
              showSuccessMsgToast( t('message.tfaCodeSentByEmailMsg', { 1: username.value }) as string);
              return;
            } else {
              isTfaRequired.value = false;
            }

              superAdminCred.value = await userModule.isCred('SUPERADMIN');

            if (user && user.preferredLanguageCode) {
              locale.value = user.preferredLanguageCode;
            }

              if (route.params && route.params.origin && route.params.origin.length) {
              console.log('route.params');
              router.push({
                name: route.params.origin as string,
                params: route.params,
              });
            } else if (route.query && route.query.origin && route.query.origin.length) {
              router.push({
                name: route.query.origin as string,
                query: route.query,
              });
            } else if (superAdminCred.value) {
              router.push({ name: 'dashboard' });
            } else if (tenant.value && tenant.value.reportsOnlyAccess) {
              router.push({ name: 'reports' });
            } else if (tenant.value && tenant.value.messageCenterStandalone) {
              router.push({ name: 'messagecenter' });
            } else {
              router.push({ name: 'dashboard' });
            }
          }
        } catch (error: any) {
          if (error.message.includes('TFA_CODE_ERROR')) {
            showErrorMsgToast(t('message.failedTfaCodeError', { 1: username.value }) as string);
          }
          else if (error.message.includes('AUTHORIZATION_ERROR')) {
            // loginError.value = t(
            //     'message.failedUnauthorizedError'
            // ) as string;
            showErrorMsgToast(t('message.failedUnauthorizedError') as string);
          }
          else {
            console.log(error);
            showLoginError();
          }
        }
      }
    }
};


// Define asynchronous delay function
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const showLoginError = () => {
  $q.notify({
    color: 'pink-7',
    icon: 'warning',
    position: 'top',
    message: t('message.failedLoginMsg') as string,
  });
};

const displayLogin = () => {
  if (tenantModule.isSuperAdminATSLoginAllowed) {
    return true;
  } else {
    return !hideLogin.value;
  }
};



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!processLoading.value && displayLogin())
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 0,
          class: "q-pa-md chb-card bg-white shadow-7"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TenantInfo, { tenantLoginInfo: tenantLoginInfo.value }, null, 8, ["tenantLoginInfo"])
            ]),
            _createVNode(_component_q_form, {
              onSubmit: _withModifiers(onSubmitLogin, ["prevent","stop"])
            }, {
              default: _withCtx(() => [
                (isShowResetPassword.value == false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(QInput), {
                          filled: "",
                          clearable: "",
                          color: "primary",
                          ref_key: "usernameRef",
                          ref: usernameRef,
                          modelValue: username.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                          label: _ctx.$t('message.userNameLbl'),
                          autocomplete: "username",
                          autofocus: "",
                          "lazy-rules": "",
                          disable: isTfaRequired.value,
                          rules: [
                val => (val && val.length > 0) || _ctx.$t('message.usernameReqMsg')
              ]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "person" })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "disable", "rules"]),
                        _createVNode(_unref(QInput), {
                          filled: "",
                          clearable: "",
                          color: "primary",
                          ref_key: "passwordRef",
                          ref: passwordRef,
                          modelValue: password.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                          label: _ctx.$t('message.passwordLbl'),
                          type: isPwd.value ? 'password' : 'text',
                          autocomplete: "current-password",
                          "lazy-rules": "",
                          disable: isTfaRequired.value,
                          rules: [
                val => (val && val.length > 0) || _ctx.$t('message.passwordReqMsg')
              ]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "lock" })
                          ]),
                          append: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: isPwd.value ? 'visibility_off' : 'visibility',
                              class: "cursor-pointer",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (isPwd.value = !isPwd.value))
                            }, null, 8, ["name"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "type", "disable", "rules"]),
                        (isTfaRequired.value)
                          ? (_openBlock(), _createBlock(_unref(QInput), {
                              key: 0,
                              filled: "",
                              clearable: "",
                              color: "primary",
                              ref_key: "tfaCodeRef",
                              ref: tfaCodeRef,
                              modelValue: tfaCode.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tfaCode).value = $event)),
                              label: _ctx.$t('message.tfaCodeLbl'),
                              autofocus: "",
                              "lazy-rules": "",
                              rules: [
                val =>
                  (val && val.length == 6) ||
                  _ctx.$t('message.tfaReqMsg', {
                    1: username.value
                  })
              ]
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_q_icon, { name: "mark_email_unread" })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "label", "rules"]))
                          : _createCommentVNode("", true),
                        (isTfaRequired.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_q_btn, {
                                flat: "",
                                "no-caps": "",
                                color: "primary",
                                label: _ctx.$t('message.cancelLbl'),
                                size: "md",
                                align: "right",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => {
                  isTfaRequired.value = false;
                  tfaCode.value = null;
                })
                              }, null, 8, ["label"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_Transition, {
                          appear: "",
                          "enter-active-class": "animated fadeIn",
                          "leave-active-class": "animated fadeOut"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              "no-caps": "",
                              rounded: "",
                              icon: "send",
                              type: "submit",
                              label: _ctx.$t('message.loginBtnLbl'),
                              class: "q-my-md full-width",
                              color: "primary"
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        (!isTfaRequired.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_q_btn, {
                                flat: "",
                                color: "primary",
                                label: _ctx.$t('message.forgotPasswordLbl'),
                                size: "sm",
                                align: "right",
                                onClick: onSwitchToResetPassword
                              }, null, 8, ["label"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isShowResetPassword.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_unref(QInput), {
                          filled: "",
                          clearable: "",
                          color: "primary",
                          modelValue: email.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((email).value = $event)),
                          ref_key: "emailRef",
                          ref: emailRef,
                          label: _ctx.$t('message.emailLbl'),
                          autofocus: "",
                          "lazy-rules": "",
                          rules: [
                val =>
                  (val && val.length > 0 && emailRegEx.test(val)) ||
                  _ctx.$t('message.emailReqMsg')
              ]
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_q_icon, { name: "person" })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "rules"]),
                        _createVNode(_Transition, {
                          appear: "",
                          "enter-active-class": "animated fadeIn",
                          "leave-active-class": "animated fadeOut"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_btn, {
                              "no-caps": "",
                              rounded: "",
                              icon: "send",
                              type: "submit",
                              label: _ctx.$t('message.reqNewPasswordLbl'),
                              class: "q-my-md full-width",
                              color: "primary"
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_q_btn, {
                            flat: "",
                            color: "primary",
                            label: _ctx.$t('message.backLbl'),
                            size: "sm",
                            align: "right",
                            onClick: onSwitchToLogin
                          }, null, 8, ["label"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)),
    (loadingIndicatorVisible.value)
      ? (_openBlock(), _createBlock(LoadingIndicator, {
          key: 2,
          showLoading: processLoading.value
        }, null, 8, ["showLoading"]))
      : _createCommentVNode("", true)
  ]))
}
}

})